import axios from 'axios';
import { Message } from "element-ui";

const urls = process.env.REQUEST_BASE_URL;
console.log("urls -> ",urls)

// 登录请求方法
const loginreq = (method, url, params) => {
    console.log(url);
    return axios({
        method: method,
        url: url,
        headers: {

        },
        data: params,

        traditional: true,

        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};


// 通用公用方法
const reqpost = (method, url, params) => {
    // let ther =this
    return axios({
        method: method,
        url: urls+url,
        headers: {
            'Content-Type': 'application/json',
            'tokenId':localStorage.getItem('tokenId')
        },
        data:params,
        // traditional: true,
    }).then(res=>{
        if(res.code==999){

              localStorage.removeItem('tokenId')
              this.$store.commit('logout', 'false')
              this.$router.push({ path: '/login' })
              Message({
                type: 'warning',
                message: '登录过期,请重新登录'
              })
              return
          }else if(res.data.code==0){
            return res.data
          }else{
            Message({
                type: "warning",
                message: res.data.message
              });

          }
    });


};
const reqget = (method, url, params) => {
    let ther =this
    return axios({
        method: method,
        url: urls+url,
        headers: {
            'Content-Type': 'application/json',
            'tokenId':localStorage.getItem('tokenId')
        },
        params,
        // traditional: true,
    }).then(res=>{


        if(res.code==999){
              localStorage.removeItem('tokenId')


            //   this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
              Message({
                type: 'warning',
                message: '登录过期,请重新登录'
              })
              return

          }else if(res.data.code==0){
            return res.data
          }else{

            Message({
                type: "warning",
                message: res.data.message
              });
              return res.data

          }
    });


};

export {
  loginreq,
  reqget,
  reqpost
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js